// Amber banner shown on the heatmap page when the relay heartbeat is
// stale. With relay down, PhoneService.list forces is_online=False on
// every phone, so the whole board reads as offline — the banner explains
// that this is a relay outage, not the actual fleet state.

export function RelayDownBanner() {
  return (
    <div
      role="alert"
      className="rounded-lg border border-amber-300 bg-amber-50 dark:border-amber-700 dark:bg-amber-900/30 px-4 py-3 text-sm text-amber-900 dark:text-amber-200"
    >
      <strong className="font-semibold">Relay сервер недоступен.</strong>{' '}
      Все телефоны показаны оффлайн намеренно — реальное состояние звонков
      сейчас неизвестно.
    </div>
  )
}
